module.exports = __webpack_public_path__ + "img/slide3.92b89b98.jpg";